import { gql } from "@apollo/client";

export const GET_ACTIVE_TENANT_PRIVILEGES = gql`
  query GetActiveTenantPrivileges {
    getActiveTenantPrivileges {
      tenant_id
      privilege_token
    }
  }
`;
